module.exports = __webpack_public_path__ + "img/193.88cef65e.jpg";